export function getCurrentUser() {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isAdminUser(user = getCurrentUser()) {
  if (!user) return false;
  if (user.isAdmin === true) return true;
  const role = typeof user.role === 'string' ? user.role.toLowerCase() : '';
  if (role === 'admin') return true;
  return user.permissions?.admin === true;
}

export function hasPermission(key, user = getCurrentUser()) {
  if (!user) return false;
  if (isAdminUser(user)) return true;
  return user.permissions?.[key] === true;
}
